import type {
  IReportTable,
  ReportRowType,
  ReportValueType,
} from '~/presentation/reports/common/type';

export interface ReportColumnLayout {
  width?: string;
  minWidth?: string;
  maxWidth?: string;
  paddingInline?: string;
  paddingRight?: string;
  columnFirstPaddingInline?: string;
  columnWrapperWidth?: string;
  align?: 'start' | 'center' | 'end';
  headerPaddingRight?: string;
  dimensionBoxShadow?: string;
  borderRightWidth?: string;
}

export type ReportColumnLayoutMap = Record<string, ReportColumnLayout>;

export enum EOrderDirectionType {
  ASC = 'ASC',
  DESC = 'DESC',
}
export type OrderDirectionType = EOrderDirectionType.ASC | EOrderDirectionType.DESC;
export type OrderByType = {
  field: string;
  direction: OrderDirectionType;
};

export type OrderByFields = Record<string, OrderByType>;

export type OrderTooltipType = Record<string, Record<OrderDirectionType, string>>;

export type OrderCellProps = {
  orderList: IReportTable<ReportValueType>;
  isFetching: boolean;
  onClickOrderCell: (data: { row?: ReportRowType; isPrevious?: boolean }) => void;
};

export interface CampaignsCellProps {
  orderId: string;
  isHideCampaignContent: boolean;
}
